import i18n from '../../locales/index'
import restful from '../vuex'

const state = {
  ...restful.states('booking_store_product')
}

const getters = {
  ...restful.getters('booking_store_product')
}

const actions = {
  ...restful.actions('booking_store_products')
}

const mutations = {
  ...restful.mutations('booking_store_product')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
